import { defineStore } from 'pinia';

export const useAlertStore = defineStore('alert', {
    state: () => ({
        alerts: [],
        lastId: 0,
    }),
    actions: {
        _push(text, alertClass, icon, autoDismiss, duration = 10 * 1000) {
            this.lastId += 1;
            const newAlert = {
                id: this.lastId,
                class: alertClass,
                text,
                icon,
                autoDismiss,
                duration,
            };
            this.alerts.push(newAlert);

            if (autoDismiss) {
                const vm = this;
                setTimeout(() => {
                    vm.remove(newAlert.id);
                }, duration);
            }
        },

        pushInfo(text, autoDismiss = true) {
            this._push(text, 'alert-info', 'fi-info', autoDismiss);
        }, // good messages are auto-dismissed by default
        pushWarning(text, autoDismiss = true) {
            this._push(text, 'alert-warning', 'fi-alert-circle', autoDismiss);
        }, // bad messages are not auto-dismissed by default
        pushError(text, autoDismiss = true) {
            this._push(text, 'alert-danger', 'fi-alert-circle', autoDismiss);
        },
        pushSuccess(text, autoDismiss = true) {
            this._push(text, 'alert-success', 'fi-check', autoDismiss);
        },

        remove(alertId) {
            const index = this.alerts.findIndex((a) => a.id == alertId);
            this.alerts.splice(index, 1);
        },
        removeAll() {
            this.alerts = [];
        },
    },
});
